/** Канонические mode для POST /api/verse/insight/guest (как GuestVerseInsightModes на бэкенде). */
export const GuestVerseInsightMode = {
  Explain: 'explain',
  Simple: 'simple',
  Application: 'application',
};

export const GUEST_VERSE_INSIGHT_MODES = [
  GuestVerseInsightMode.Explain,
  GuestVerseInsightMode.Simple,
  GuestVerseInsightMode.Application,
];

/** Порядок ссылок на главной: без «Разобрать», первым — simple (в UI «Объяснение»). */
export const HOME_INSIGHT_MODE_ORDER = [
  GuestVerseInsightMode.Simple,
  GuestVerseInsightMode.Application,
];
